import { apiCall } from '@/util/apiCall'
import type { Connection } from '@common/types/Area'
import type { Stop } from '@common/types/Stop'
import { setConnections } from '../connections'
import { setLoadingState } from '../loading'
import { setStops } from '../stops'
import { makeLoader } from './load'

export const loadConnectionsByArea = makeLoader<{
	area: string
}>({
	id: ({ area }) => `connectionsByArea:${area}`,
	loader: async (api, { area }) => {
		const {
			data: [connections, stops],
		} = await apiCall<{ data: [Connection[], Stop[]] }>(
			'/areas/:area/connections',
			{
				signal: api.signal,
				params: { area },
				cache: 'preload-if-ssr',
			},
		)
		return [
			setConnections({ area, connections }),
			setStops(stops),
			setLoadingState([`stopsByArea:${area}`, { status: 'loaded' }]),
		]
	},
})
